import { Routes } from '@angular/router';
import { UserRole } from './shared/enums/UserRole.enum';
import { provideStates } from '@ngxs/store';
import { AdminState } from './shared/state/admin/admin.state';
import { GckAssignmentState } from './shared/state/gck-assignment/gck-assignment.state';
import { MsalRoleGuard } from './shared/guards/role-based-msal.guard';
import { TruncatePipe } from './shared/pipes/truncate.pipe';
import { LuxonDateFormatPipe } from './shared/pipes/date.pipe';

export const routes: Routes = [
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./auth/components/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
    },
    {
        path: 'home',
        loadComponent: () => import('./dashboard/dashboard.component').then(component => component.DashboardComponent),
        canActivate: [MsalRoleGuard],
        providers: [TruncatePipe, LuxonDateFormatPipe],
        data: {
            roles: [
                UserRole.ADMIN,
                UserRole.COMMERCIALS,
                UserRole.CUSTOMS,
                UserRole.CUSTOMER_SUPPORT,
                UserRole.E_COMMERCE,
                UserRole.EXPORT_CLASSIFICATION,
                UserRole.FACTORY_DATA_MANAGER,
                UserRole.KNOWLEDGE_MANAGER,
                UserRole.LOGISTICS,
                UserRole.PRODUCT_LIFECYCLE_MANAGER
            ]
        }
    },
    {
        path: 'workflows',
        loadChildren: () => import('./workflows/workflow.routes').then(routes => routes.WORKFLOW_ROUTES),
        canActivate: [MsalRoleGuard],
        data: {
            roles: [
                UserRole.ADMIN,
                UserRole.COMMERCIALS,
                UserRole.CUSTOMS,
                UserRole.CUSTOMER_SUPPORT,
                UserRole.E_COMMERCE,
                UserRole.EXPORT_CLASSIFICATION,
                UserRole.FACTORY_DATA_MANAGER,
                UserRole.KNOWLEDGE_MANAGER,
                UserRole.LOGISTICS,
                UserRole.PRODUCT_LIFECYCLE_MANAGER
            ]
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then(r => r.ADMIN_ROUTES),
        canActivate: [MsalRoleGuard],
        providers: [provideStates([AdminState, GckAssignmentState])],
        data: {
            roles: [UserRole.ADMIN]
        }
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' }
];
